import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IAGroupList } from '../../../groupList/GroupList';
import { GroupListGroup, GroupList, GroupListItem, GroupListColumnType } from '../../../../interfaces/IGroupList'
import { IApplication, Instance, IStoredObject } from '../../../../interfaces/IApplication';
import { IAIcon } from '../../../icon/Icon';
import { ApplicationsSettings } from './ApplicationsSettings';
import { TargetingAdminStore } from '../../stores/TargetingAdminStore';
import { IASpinner } from '../../../spinner/Spinner';
import { LocalizationService } from './../../../../services/LocalizationService';
import { ITenantSettings } from '../../../../interfaces/ITenantSettings';
import { TenantSettingsService } from 'intraactive-sdk-helper';
import { Environment } from '../../../../services/Environment';
import DateTimeService from '../../../../services/DateTimeService';
import { sdkContainerInstance } from '../../../global';
import { Helper } from '../../../../Helper';

export interface IApplicationsProps {
  targetingStore?: TargetingAdminStore;
}

export interface IApplicationsState {
  openPanel: boolean;
  itemSelected: Instance;
  applicationSelected: IApplication;
}

@inject('targetingStore')
@observer
export class Applications extends React.Component<IApplicationsProps, IApplicationsState> {

  private readonly tenantSettingsService: TenantSettingsService<ITenantSettings>;
  constructor(props: IApplicationsProps, state: IApplicationsState) {
    super(props, state);
    this.state = {
      openPanel: false,
      applicationSelected: undefined,
      itemSelected: undefined,
    }
    if (this.props.targetingStore.language != undefined) {
      this.props.targetingStore.setLanguage(this.props.targetingStore.language);
    }
    this.tenantSettingsService = new TenantSettingsService<ITenantSettings>(Environment.getEnvironmentForSettingsAPI(props.targetingStore.environment), sdkContainerInstance);
    if (this.tenantSettingsService && props.targetingStore.tenant && props.targetingStore.token) {
      const tenantSettings = localStorage.getItem("IA_tenantSettings");
      if (tenantSettings && new DateTimeService().getDatePlusTwoMinuts(new Date(JSON.parse(tenantSettings).date)) > new Date()) {
        console.log("Using cached tenant settings");
        props.targetingStore.settings = JSON.parse(tenantSettings).value;
      } else {
        console.log("Fetching tenant settings again");
        this.tenantSettingsService.getSettings(props.targetingStore.tenant, {}, props.targetingStore.token).then(setting => {
          props.targetingStore.settings = setting;
          Helper.setLocalStorage("IA_tenantSettings", JSON.stringify({
            date: new Date(),
            value: setting
          }));
        });
      }
    }
  }

  public render(): JSX.Element {

    if (!this.props.targetingStore.applicationsData && this.props.targetingStore.isLoadingApplication) {
      return (<div>
        <IASpinner />
      </div>);
    }

    let applicationsData = this.getApplicationsData(this.props.targetingStore.applicationsData);

    return (
      <div>
        <div>{new LocalizationService().strings.TargetingAdmin_ApplicationDescription}</div>
        <div style={{ float: 'left', top: '120px' }}>
          <ApplicationsSettings
            close={() => this.setState({ openPanel: false })}
            open={this.state.openPanel}
            isApplication={this.state.itemSelected ? false : true}
            application={this.state.applicationSelected}
            item={this.state.itemSelected}
          />
          {!this.props.targetingStore.isLoadingApplication &&
            <IAGroupList
              highlightColor={"#025159"}
              groupsItem={applicationsData}
              getUpdates={(items, selectedItem, selectedGroup) => {
                console.log(items);
                let data: Instance = undefined;
                let application: IApplication = undefined;
                if (selectedGroup) {
                  application = this.props.targetingStore.applicationsData.find(x => x.name === selectedGroup);
                  data = application.instances.find(x => x.id === selectedItem.id);
                } else {
                  application = this.props.targetingStore.applicationsData.find(x => x.name === selectedItem.title);
                }
                this.setState({ applicationSelected: application, openPanel: true, itemSelected: data });
              }}
            />}
        </div>
      </div>);
  }

  private getData(application: IApplication) {
    const instances = application.instances.sort((a1, a2) => {
      // defensive check to remove any null/undefined names before calling toLocaleLowerCase()
      const a1Name = a1.name ?? "";
      const a2Name = a2.name ?? "";

      if (a1Name.toLocaleLowerCase() > a2Name.toLocaleLowerCase()) {
        return 1;
      }
      if (a1Name.toLocaleLowerCase() < a2Name.toLocaleLowerCase()) {
        return -1;
      }
      return 0;
    });
    const items: GroupListItem[] = instances.map((item) => {
      return {
        title: item.name,
        id: item.id,
        name: item.name,
        columns: [
          {
            field: "column1",
            title: new LocalizationService().strings.TargetingAdmin_ApplicationColumnName,
            type: GroupListColumnType.Text,
            value: item.name
          },
          {
            field: "column2",
            title: "",
            type: GroupListColumnType.Icon,
            value: false
          },
          {
            field: "column3",
            title: new LocalizationService().strings.TargetingAdmin_ApplicationColumnProfileDataUserGroups,
            type: GroupListColumnType.Text,
            value: (<div>
              {item.isEnable &&
                <div style={{ position: 'relative', top: '3px' }}>
                  <div style={{ float: 'left', position: 'relative', top: '5px' }}>
                    <IAIcon
                      title={(application.name.toLocaleLowerCase() === 'content organizer' && item.type === "userGroups") ? "People" : (application.default.type === "userGroups") ? "People" : "Tag"}
                      color={this.props.targetingStore.highlightColor}
                      size={17} />
                  </div>
                  {(item.values && item.values.length > 0) &&
                    <div style={{ float: 'left', position: 'relative' }}>{this.getSelectedValues((item.type === application.default.type || application.name.toLocaleLowerCase() === 'content organizer') ? item.values : [], item.allValues, item.useDefault)}</div>
                  }
                </div>
              }
            </div>
            )
          }
        ]
      }

    });

    let displayColumn2 = true;
    if (application.name.toLocaleLowerCase() === 'toolbox' && this.props.targetingStore.settings && this.props.targetingStore.settings.admin) {
      displayColumn2 = false;
    } else if (application.name.toLocaleLowerCase() === 'content organizer') {
      displayColumn2 = false;
    }

    const groupValues = {
      title: application.name,
      id: application.id,
      name: application.name,
      columns: [
        {
          field: "column2",
          title: "",
          type: displayColumn2 ? GroupListColumnType.Icon : GroupListColumnType.Text,
          value: displayColumn2 ? false : ''
        },
        {
          field: "column3",
          title: new LocalizationService().strings.TargetingAdmin_ApplicationColumnProfileDataUserGroups,
          type: GroupListColumnType.Text,
          value: (
            <div>{
              application.default.isEnable &&
              <div style={{ position: 'relative', top: '3px' }}>
                <div style={{ float: 'left', position: 'relative', top: '5px' }}>
                  <IAIcon
                    title={application.default.type === "userGroups" ? "People" : "Tag"}
                    color={this.props.targetingStore.highlightColor}
                    size={17} />
                </div>
                {(application.default.values && application.default.values.length > 0) &&
                  <div style={{ float: 'left', position: 'relative', marginLeft: 7, marginTop: 3 }}>{this.getSelectedValues(application.default.values, application.default.allValues)}</div>
                }
              </div>
            }
            </div>
          )
        }
      ]
    };

    const group: GroupListGroup = {
      name: application.name,
      expanded: false,
      title: application.name,
      items,
      // hideTitle: true,
      // borderEveryItem: true,
      clickableGroupTitle: true,
      groupValues
    };
    return group;

  }

  // private getLabels(data: StoredObject[]) {
  //   let labels: string = '';

  // }

  private getApplicationsData(applications: IApplication[]) {

    let list = applications.sort((a1, a2) => {
      if (a1.name.toLocaleLowerCase() > a2.name.toLocaleLowerCase()) {
        return 1;
      }
      if (a1.name.toLocaleLowerCase() < a2.name.toLocaleLowerCase()) {
        return -1;
      }
      return 0;
    });

    let groups = list.map(application => {
      return this.getData(application);
    });
    const columnsTitle = [{ title: new LocalizationService().strings.TargetingAdmin_ApplicationColumnName, name: "column1" }, { title: "", name: "column2" }, { title: new LocalizationService().strings.TargetingAdmin_ApplicationColumnProfileDataUserGroups, name: "column3" }];
    const groupList: GroupList = {
      columns: columnsTitle,
      groups: groups,
      hideFirstColumn: true
    }
    return groupList;
  }

  private getSelectedValues(list: IStoredObject[], allResults: boolean, defaultValues?: boolean) {
    let value = '';
    if (allResults) {
      return 'All';
    } else {
      if (!defaultValues && list && list.length > 0) {
        let selectedList = list.filter(x => x.value || x.value === undefined);
        let maxLabels = selectedList.length < 4 ? selectedList.length : 4;
        for (let i = 0; i < maxLabels; i++) {
          value += selectedList[i].label + ((i === (maxLabels - 1)) ? '' : ', ');
        }
        if (selectedList.length > 4) {
          value += '...';
        }
      }
    }
    return value;
  }

}